var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "UiCard",
    { staticClass: "IDCard text-gray-600 relative d-flex flex-column" },
    [
      _c("div", { staticClass: "row flex-1" }, [
        _c("div", { staticClass: "col-4" }, [
          _c("div", {
            staticClass: "img-mask rounded",
            style: {
              backgroundImage:
                "url(" +
                _vm.propOrPlaceholder(_vm.imageLink, _vm.userPlaceholder) +
                ")",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col pl-0" }, [
          _c(
            "div",
            { staticClass: "text-lg font-semibold mt-1" },
            [
              !!_vm.title
                ? _c("span", [_vm._v(_vm._s(_vm.title))])
                : _c("UiSkeleton", {
                    staticStyle: {
                      "max-width": "150px",
                      "min-height": "1.5em",
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-3" },
            [
              !!_vm.comment
                ? _c("span", [_vm._v(_vm._s(_vm.comment))])
                : _c("UiSkeleton", {
                    staticStyle: {
                      "max-width": "120px",
                      "min-height": "1.25em",
                    },
                  }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-mono" },
        [
          !!_vm.serial
            ? _c("span", [_vm._v(_vm._s(_vm.serial))])
            : _c("UiSkeleton", {
                staticStyle: { "max-width": "120px", "min-height": "1.25em" },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }